
import React from 'react';
import { Helmet } from 'react-helmet';

interface MetaHeadProps {
  title?: string;
  description?: string;
  image?: string;
  url?: string;
}

const MetaHead: React.FC<MetaHeadProps> = ({
  title = "BubbleCare | Connected Care Networks for Your Loved Ones",
  description = "Connect Your Loved One's Care Network with BubbleCare",
  image = "/lovable-uploads/c43492c6-9bd3-4c28-aac2-d61ab718c15d.png",
  url = "https://bubblecare.app/"
}) => {
  // Ensure absolute URL for the image
  const absoluteImageUrl = image.startsWith('http') ? image : `https://bubblecare.app${image}`;
  
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      
      {/* OpenGraph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={absoluteImageUrl} />
      <meta property="og:site_name" content="BubbleCare" />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={absoluteImageUrl} />
      <meta name="twitter:site" content="@BubbleCare" />
      
      {/* Additional metadata to help with social previews */}
      <meta name="application-name" content="BubbleCare" />
      <meta name="msapplication-TileColor" content="#9561e2" />
      <meta name="theme-color" content="#9561e2" />
      <meta name="apple-mobile-web-app-title" content="BubbleCare" />
      
      {/* Canonical link to prevent duplicate content issues */}
      <link rel="canonical" href={url} />
      
      {/* Cache control to ensure fresh content */}
      <meta httpEquiv="Cache-Control" content="no-cache, no-store, must-revalidate" />
      <meta httpEquiv="Pragma" content="no-cache" />
      <meta httpEquiv="Expires" content="0" />
    </Helmet>
  );
};

export default MetaHead;
